export default __webpack_public_path__ + "images/F9.5c5e7ee.png";